/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const pwa = {
  pwa: {
    addToHomeScreenDescription:
      'Adicione ID Vitrine à tela inicial do seu dispositivo para uma visita de retorno mais rápida',
    noInstallationNeeded: 'Não é necessária instalação',
    fastAccessToApplication: 'Acesso rápido ao aplicativo',
    addToHomeScreen: 'Adicionar à tela inicial',
    addedToHomeScreen: 'ID Storefront foi adicionado à tela inicial',
  },
};
